document.addEventListener("DOMContentLoaded", () => {
    fetch(jsonUrl)
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .then(shopData => {
            updateNavigation(shopData); // ナビゲーションを生成
            generateShopList(shopData); // ショップリストを生成
            setupSmoothScroll(); // スムーススクロールのセットアップ
        })
        .catch(error => {
            console.error('Error loading shop list:', error);
        });

    function updateNavigation(shopData) {
        const areaIdMap = {
            "北海道・東北": "area01",
            "関東": "area02",
            "中部": "area03",
            "近畿": "area04",
            "中国": "area05",
            "四国": "area06",
            "九州・沖縄": "area07"
        };

        const availableAreas = new Set(shopData.map(shop => shop.area));
        const navList = document.querySelector('#snav_area ul');
        navList.innerHTML = ''; // ナビゲーションをクリア

        Object.keys(areaIdMap).forEach(areaName => {
            const areaId = areaIdMap[areaName];
            const navItem = document.createElement('li');

            if (!availableAreas.has(areaName)) {
                navItem.classList.add('none'); // JSONに存在しない場合クラスを追加
            }

            navItem.innerHTML = `<a href="#${areaId}">${areaName}</a>`;
            navList.appendChild(navItem);
        });
    }

    function generateShopList(shopData) {
        const areaIdMap = {
            "北海道・東北": "area01",
            "関東": "area02",
            "中部": "area03",
            "近畿": "area04",
            "中国": "area05",
            "四国": "area06",
            "九州・沖縄": "area07"
        };

        const container = document.querySelector('#shoplist_area .inner');

        const groupedData = shopData.reduce((acc, shop) => {
            if (!acc[shop.area]) acc[shop.area] = {};
            if (!acc[shop.area][shop.pref]) acc[shop.area][shop.pref] = [];
            acc[shop.area][shop.pref].push(shop);
            return acc;
        }, {});

        Object.keys(groupedData).forEach(area => {
            const areaBox = document.createElement('div');
            areaBox.classList.add('area_box');
            areaBox.id = areaIdMap[area];

            const areaTitle = document.createElement('h3');
            areaTitle.textContent = area;
            areaBox.appendChild(areaTitle);

            const areaInner = document.createElement('div');
            areaInner.classList.add('area_inner');

            Object.keys(groupedData[area]).forEach(pref => {
                const prefBox = document.createElement('div');
                prefBox.classList.add('prefectures');

                const prefTitle = document.createElement('h4');
                prefTitle.textContent = pref;
                prefBox.appendChild(prefTitle);

                const shopDataDiv = document.createElement('div');
                shopDataDiv.classList.add('shop_data');

                const header = document.createElement('article');
                header.innerHTML = `
                    <p>店舗名</p>
                    <p>住所</p>
                    <p>電話番号</p>
                `;
                shopDataDiv.appendChild(header);

                groupedData[area][pref].forEach(shop => {
                    const shopArticle = document.createElement('article');
                    shopArticle.innerHTML = `
                        <p>${shop.shop_name}</p>
                        <p><span>住所</span>${shop.address}</p>
                        <p><span>電話番号</span>${shop.tel}</p>
                    `;
                    shopDataDiv.appendChild(shopArticle);
                });

                prefBox.appendChild(shopDataDiv);
                areaInner.appendChild(prefBox);
            });

            areaBox.appendChild(areaInner);
            container.appendChild(areaBox);
        });
    }

    function setupSmoothScroll() {
        // 動的生成されたリンクを含むすべてのリンクにスムーススクロールを設定
        const navLinks = document.querySelectorAll('#snav_area a');

        navLinks.forEach(link => {
            link.addEventListener('click', event => {
                event.preventDefault();

                const targetId = link.getAttribute('href').replace('#', '');
                const targetElement = document.getElementById(targetId);

                if (targetElement) {
                    targetElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            });
        });
    }
});